export const convertToSVP = ({ temperature, humidity }) => {
  return (
    (0.61078 *
      Math.pow(Math.E, (17.27 * temperature) / (temperature + 237.3)) *
      humidity) /
    100
  )
}
